module.exports = "https://portperrypedals.ca/_res/img/lalonde.c20c924.png";